module.exports = __webpack_public_path__ + "img/24_45.151c5dd6.png";